export default "__VITE_ASSET__CMVHhdhT__"